<script setup="">
import { computed, inject } from "vue";

const props = defineProps({
  tooltip: {
    type: String,
    required: false,
    default: ""
  },
  buttonClass: {
    type: String,
    required: false
  }
});

const twMerge = inject("twMerge");

const defaultClass = "btn h-9 w-9 rounded-full p-0 border-0";

const computedClass = computed(() => twMerge(defaultClass, props.buttonClass));
</script>

<template>
  <button v-tippy="{ content: tooltip }" :class="computedClass">
    <slot />
  </button>
</template>
